import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
export const HTMLTooltip = styled(({
  className,
  arrow = true,
  ...props
}) => <Tooltip {...props} classes={{
  popper: className
}} arrow={arrow} />)(({
  theme
}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1]
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'whitesmoke'
  }
}));